import React, { Component } from 'react'
import T from 'i18n-react'
import { IconButton, FontIcon } from 'react-toolbox'

import { Tab } from 'react-toolbox/lib/tabs'
import CSSModules from 'react-css-modules'
import { connect } from 'react-redux'
import cloneDeep from 'lodash/cloneDeep'
import { nest, branch, renderNothing } from 'recompose'
import styles from './styles.scss'
import { compose } from 'recompose'

import {
  MODULES,
} from './constants'

import ModuleHeaderContainer from 'components/project/ModuleHeaderContainer/index'
import CommonSpec from 'containers/Project/CommonSpec/index'
import ClockSpec from 'containers/Project/ClockSpec/index'
import FeatureSpec from 'containers/Project/FeatureSpec/index'
import ScheduleSpec from 'containers/Project/ScheduleSpec/index'
import GeneralSpec from 'containers/Project/GeneralSpec/index'
import SystemSpec from 'containers/Project/SystemSpec/index'
import PcbStackUpSpec from 'containers/Project/PcbStackupSpec/index'
import VoltageRegulatorSpec from 'containers/Project/VoltageRegulatorSpec/index'
import PowerComponentsSpec from 'containers/Project/PowerComponentsSpec/index'
import PanelSpec from 'containers/Project/PanelSpec/index'
import InputConnectorSpec from 'containers/Project/InputConnectorSpec/index'
import DisplaySpec from 'containers/Project/DisplaySpec/index'
import MemorySpec from 'containers/Project/MemorySpec/index'
import MissionProfileSpec from 'containers/Project/MissionProfileSpec'
import CpuSpec from 'containers/Project/CpuSpec/index'
import MultiListSpec from 'containers/Project/MultiListSpec/index'
import SpecHeaderComponent from './SpecHeader'
import { brandSelector } from '../View/selectors';

import SystemManagementAndFirmwareSpec from 'containers/Project/SystemManagementAndFirmwareSpec/index'
import SystemPowerSupplySpec from 'containers/Project/SystemPowerSupplySpec/index'
import PowerMonitorIcSpec from 'containers/Project/PowerMonitorIcSpec/index'
import HorizontalTableSpec from 'containers/Project/HorizontalTableSpec/index'

import { Element } from 'react-scroll'


class SpecificationData extends Component {
  renderSpecs(curFilter, groupedData, isModifiedPage) {
    if (Object.keys(groupedData).length === 0) return
    return MODULES.map((sectionKey, index) => {
      const getTitle = key => T.translate(`project.spec.${key}`)
      let items = null

      const SpecHeader = branch(
          () => sectionKey !== 'project' || !isModifiedPage,
          renderNothing
        )(SpecHeaderComponent)
      const ModuleHeader = nest(ModuleHeaderContainer,
        () => <span> {getTitle(sectionKey)} </span>
      )
      switch (sectionKey) {
      case 'schedule':
        break;
      case 'project':
        items =
          <GeneralSpec
            moduleData={ groupedData }
            isModifiedPage={isModifiedPage}
            curFilter={curFilter}
            ModuleHeader={ ModuleHeader }
          />
        break
      case 'system':
        items =
          <SystemSpec
            moduleData={ groupedData }
            isModifiedPage={isModifiedPage}
            curFilter={curFilter}
            ModuleHeader={ ModuleHeader }
          />
        break
      case 'default_cpu':
          items =
            <CpuSpec
              moduleData={ groupedData }
              isModifiedPage={isModifiedPage}
              curFilter={curFilter}
              ModuleHeader={ ModuleHeader }
            />
          break
      case 'cpu':
        items =
          <CpuSpec
            moduleData={ groupedData }
            isModifiedPage={isModifiedPage}
            curFilter={curFilter}
            ModuleHeader={ ModuleHeader }
          />
        break
      case 'panel':
        items =
          <PanelSpec
            moduleData={ groupedData }
            isModifiedPage={isModifiedPage}
            curFilter={curFilter}
            ModuleHeader={ ModuleHeader }
          />
        break
      case 'pcb_stackup':
        items =
          <PcbStackUpSpec
            moduleData={ groupedData }
            isModifiedPage={isModifiedPage}
            curFilter={curFilter}
            ModuleHeader={ ModuleHeader }
          />
        break
      case 'memory':
        items =
          <MemorySpec
            moduleData={ groupedData }
            isModifiedPage={isModifiedPage}
            curFilter={curFilter}
            ModuleHeader={ ModuleHeader }
          />
        break
      case 'input_connector':
        items =
          <InputConnectorSpec
            moduleData={ groupedData }
            isModifiedPage={isModifiedPage}
            curFilter={curFilter}
            ModuleHeader={ ModuleHeader }
          />
        break
      case 'system_management_and_firmware':
        items =
          <SystemManagementAndFirmwareSpec
            moduleData={ groupedData }
            isModifiedPage={isModifiedPage}
            curFilter={curFilter}
            ModuleHeader={ ModuleHeader }
          />
        break
      case 'system_power_supply':
        items =
          <SystemPowerSupplySpec
            moduleData={ groupedData }
            isModifiedPage={isModifiedPage}
            curFilter={curFilter}
            ModuleHeader={ ModuleHeader }
          />
        break
      case 'power_monitor_ic':
        items =
          <PowerMonitorIcSpec
            moduleData={ groupedData }
            isModifiedPage={isModifiedPage}
            curFilter={curFilter}
            ModuleHeader={ ModuleHeader }
          />
        break
      case 'display_connector':
        items =
          <DisplaySpec
            moduleData={ groupedData }
            isModifiedPage={isModifiedPage}
            curFilter={curFilter}
            ModuleHeader={ ModuleHeader }
          />
        break
      case 'voltage_regulator':
        items =
          <VoltageRegulatorSpec
            moduleData={ groupedData }
            isModifiedPage={isModifiedPage}
            curFilter={curFilter}
            ModuleHeader={ ModuleHeader }
          />
        break
      case 'power_components':
        items =
          <PowerComponentsSpec
            moduleData={ groupedData }
            isModifiedPage={isModifiedPage}
            curFilter={curFilter}
            ModuleHeader={ ModuleHeader }
          />
        break
      case 'project_feature':
        items =
          <FeatureSpec
            moduleData={ groupedData }
            isModifiedPage={isModifiedPage}
            curFilter={curFilter}
            ModuleHeader={ ModuleHeader }
          />
        break
      case 'clock':
        items =
          <ClockSpec
            moduleData={ groupedData }
            isModifiedPage={isModifiedPage}
            curFilter={curFilter}
            ModuleHeader={ ModuleHeader }
          />
        break
        
      case 'cpu_root_port':
        items =
          <MultiListSpec
          moduleName= {'cpu_root_port'}
          specModuleData={ groupedData['cpu_root_port'] }
          isModifiedPage={isModifiedPage}
          curFilter={curFilter}
          ModuleHeader={ ModuleHeader }
        />
        break
      case 'nic':
        items =
          <MultiListSpec
          moduleName= {'nic'}
          specModuleData={ groupedData['nic'] }
          isModifiedPage={isModifiedPage}
          curFilter={curFilter}
          ModuleHeader={ ModuleHeader }
        />
        break
      case 'pcie_switch_retimer':
          items =
            <MultiListSpec
            moduleName= {'pcie_switch_retimer'}
            specModuleData={ groupedData['pcie_switch_retimer'] }
            isModifiedPage={isModifiedPage}
            curFilter={curFilter}
            ModuleHeader={ ModuleHeader }
          />
        break
      case 'high_current_device':
          items =
            <MultiListSpec
            moduleName= {'high_current_device'}
            specModuleData={ groupedData['high_current_device'] }
            isModifiedPage={isModifiedPage}
            curFilter={curFilter}
            ModuleHeader={ ModuleHeader }
            firstRowHeader={ true }
          />
        break
      case 'lc_voltage_regulator_device':
          items =
            <MultiListSpec
            moduleName= {'lc_voltage_regulator_device'}
            specModuleData={ groupedData['lc_voltage_regulator_device'] }
            isModifiedPage={isModifiedPage}
            curFilter={curFilter}
            ModuleHeader={ ModuleHeader }
            firstRowHeader={ true }
          />
        break
      case 'memory_storage_device':
          items =
            <MultiListSpec
            moduleName= {'memory_storage_device'}
            specModuleData={ groupedData['memory_storage_device'] }
            isModifiedPage={isModifiedPage}
            curFilter={curFilter}
            ModuleHeader={ ModuleHeader }
            firstRowHeader={ true }
          />
        break
      case 'fsi_interface':
          items =
            <MultiListSpec
            moduleName= {'fsi_interface'}
            specModuleData={ groupedData['fsi_interface'] }
            isModifiedPage={isModifiedPage}
            curFilter={curFilter}
            ModuleHeader={ ModuleHeader }
            firstRowHeader={ true }
          />
        break
      case 'peripheral_interface_spi':
          items =
            <MultiListSpec
            moduleName= {'peripheral_interface_spi'}
            specModuleData={ groupedData['peripheral_interface_spi'] }
            isModifiedPage={isModifiedPage}
            curFilter={curFilter}
            ModuleHeader={ ModuleHeader }
            firstRowHeader={ true }
          />
        break
      case 'peripheral_interfaces_i_2_c':
          items =
            <HorizontalTableSpec
            moduleName= {'peripheral_interfaces_i_2_c'}
            specModuleData={ groupedData['peripheral_interfaces_i_2_c'] }
            isModifiedPage={isModifiedPage}
            curFilter={curFilter}
            ModuleHeader={ ModuleHeader }
            firstRowHeader={ true }
          />
        break
      case 'fsync_signal':
          items =
            <MultiListSpec
            moduleName= {'fsync_signal'}
            specModuleData={ groupedData['fsync_signal'] }
            isModifiedPage={isModifiedPage}
            curFilter={curFilter}
            ModuleHeader={ ModuleHeader }
            firstRowHeader={ true }
          />
        break
      case 'pwm':
          items =
            <MultiListSpec
            moduleName= {'pwm'}
            specModuleData={ groupedData['pwm'] }
            isModifiedPage={isModifiedPage}
            curFilter={curFilter}
            ModuleHeader={ ModuleHeader }
            firstRowHeader={ true }
          />
        break
      case 'uart':
          items =
            <MultiListSpec
            moduleName= {'uart'}
            specModuleData={ groupedData['uart'] }
            isModifiedPage={isModifiedPage}
            curFilter={curFilter}
            ModuleHeader={ ModuleHeader }
            firstRowHeader={ true }
          />
        break
      case 'peripheral_interfaces_dap':
          items =
            <MultiListSpec
            moduleName= {'peripheral_interfaces_dap'}
            specModuleData={ groupedData['peripheral_interfaces_dap'] }
            isModifiedPage={isModifiedPage}
            curFilter={curFilter}
            ModuleHeader={ ModuleHeader }
            firstRowHeader={ true }
          />
        break
      case 'peripheral_interfaces_can':
          items =
            <MultiListSpec
            moduleName= {'peripheral_interfaces_can'}
            specModuleData={ groupedData['peripheral_interfaces_can'] }
            isModifiedPage={isModifiedPage}
            curFilter={curFilter}
            ModuleHeader={ ModuleHeader }
            firstRowHeader={ true }
          />
        break
      case 'peripheral_interfaces_eth':
          items =
            <MultiListSpec
            moduleName= {'peripheral_interfaces_eth'}
            specModuleData={ groupedData['peripheral_interfaces_eth'] }
            isModifiedPage={isModifiedPage}
            curFilter={curFilter}
            ModuleHeader={ ModuleHeader }
            firstRowHeader={ true }
          />
        break
      case 'peripheral_interfaces_usb_2':
          items =
            <MultiListSpec
            moduleName= {'peripheral_interfaces_usb_2'}
            specModuleData={ groupedData['peripheral_interfaces_usb_2'] }
            isModifiedPage={isModifiedPage}
            curFilter={curFilter}
            ModuleHeader={ ModuleHeader }
            firstRowHeader={ true }
          />
        break
      case 'peripheral_interfaces_usb_3':
          items =
            <MultiListSpec
            moduleName= {'peripheral_interfaces_usb_3'}
            specModuleData={ groupedData['peripheral_interfaces_usb_3'] }
            isModifiedPage={isModifiedPage}
            curFilter={curFilter}
            ModuleHeader={ ModuleHeader }
            firstRowHeader={ true }
          />
        break
      case 'peripheral_interfaces_pcie':
          items =
            <MultiListSpec
            moduleName= {'peripheral_interfaces_pcie'}
            specModuleData={ groupedData['peripheral_interfaces_pcie'] }
            isModifiedPage={isModifiedPage}
            curFilter={curFilter}
            ModuleHeader={ ModuleHeader }
            firstRowHeader={ true }
          />
        break
      case 'display_hdmi':
          items =
            <HorizontalTableSpec
            moduleName= {'display_hdmi'}
            specModuleData={ groupedData['display_hdmi'] }
            isModifiedPage={isModifiedPage}
            curFilter={curFilter}
            ModuleHeader={ ModuleHeader }
          />
        break
      case 'camera_video_input':
          items =
            <HorizontalTableSpec
            moduleName= {'camera_video_input'}
            specModuleData={ groupedData['camera_video_input'] }
            isModifiedPage={isModifiedPage}
            curFilter={curFilter}
            ModuleHeader={ ModuleHeader }
            firstRowHeader={ true }
          />
        break
      case 'system_saftey_mcu':
          items =
            <HorizontalTableSpec
            moduleName= {'system_saftey_mcu'}
            specModuleData={ groupedData['system_saftey_mcu'] }
            isModifiedPage={isModifiedPage}
            curFilter={curFilter}
            ModuleHeader={ ModuleHeader }
          />
        break
      case 'system_ethernet_switch':
          items =
            <HorizontalTableSpec
            moduleName= {'system_ethernet_switch'}
            specModuleData={ groupedData['system_ethernet_switch'] }
            isModifiedPage={isModifiedPage}
            curFilter={curFilter}
            ModuleHeader={ ModuleHeader }
          />
        break
      case 'thermal_interface_material_detail':
          items =
            <MultiListSpec
            moduleName= {'thermal_interface_material_detail'}
            specModuleData={ groupedData['thermal_interface_material_detail'] }
            isModifiedPage={isModifiedPage}
            curFilter={curFilter}
            ModuleHeader={ ModuleHeader }
          />
        break
      case 'system_saftey_mcu':
        items =
          <MultiListSpec
          moduleName= {'system_saftey_mcu'}
          specModuleData={ groupedData['system_saftey_mcu'] }
          isModifiedPage={isModifiedPage}
          curFilter={curFilter}
          ModuleHeader={ ModuleHeader }
        />
        break
        case 'hgx_product_storage':
          items =
            <MultiListSpec
            moduleName= {'hgx_product_storage'}
            specModuleData={ groupedData['hgx_product_storage'] }
            isModifiedPage={isModifiedPage}
            curFilter={curFilter}
            ModuleHeader={ ModuleHeader }
          />
        break
      case 'product_storage':
          items =
            <MultiListSpec
            moduleName= {'product_storage'}
            specModuleData={ groupedData['product_storage'] }
            isModifiedPage={isModifiedPage}
            curFilter={curFilter}
            ModuleHeader={ ModuleHeader }
          />
        break
        case 'mission_profile':
          items =
            <MissionProfileSpec
            specModuleData={ groupedData['mission_profile'] }
            isModifiedPage={isModifiedPage}
            curFilter={curFilter}
            ModuleHeader={ ModuleHeader }
          />
          break
        case 'baseboard_power_components':
          items =
            <MultiListSpec
            moduleName= {'baseboard_power_components'}
            specModuleData={ groupedData['baseboard_power_components'] }
            isModifiedPage={isModifiedPage}
            curFilter={curFilter}
            ModuleHeader={ ModuleHeader }
          />
        break
      default: {
        items =
          <CommonSpec
            moduleName={ sectionKey }
            moduleData={ cloneDeep(groupedData) }
            isModifiedPage={isModifiedPage}
            curFilter={curFilter}
            ModuleHeader={ ModuleHeader }
          />
        break
      }
      }

      return (
        <div key={index}>
            <SpecHeader
              tab={this.props.tab}
              modifiedRevisionLabel={this.props.modifiedRevisionLabel}
              originalRevisionLabel={this.props.originalRevisionLabel}
              isModifiedPage={isModifiedPage}
            />
            <Element name={sectionKey} className="element">
              { items }
            </Element>
        </div>
      )
    })
  }

  render() {
    const {
      children,
      data,
      filter,
      isModified,
    } = this.props

    return (
      <div>
        { children }
        { this.renderSpecs(filter, data, isModified) }
      </div>
    )
  }
}

// export default SpecificationData
const withStyle = CSSModules(styles)
export default compose(
  withStyle
)(SpecificationData)
